import { render, staticRenderFns } from "./KnowledgeBaseItem.vue?vue&type=template&id=23e001da&scoped=true"
import script from "./KnowledgeBaseItem.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e001da",
  null
  
)

export default component.exports